 import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getBlogs, getAllBlogsAdmin } from "../services/blogService";
import Navbar from "../components/Navbar";
import SecondNavbar from "../components/SecondNavbar";  

import Footer from "../components/Footer";
import "./Blog.css";
import healthImg from "../assets/healthimg.jpg";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [expandedBlogs, setExpandedBlogs] = useState({});
  const [openBlogId, setOpenBlogId] = useState(null);

  const navigate = useNavigate();
  const isLoggedIn =!!localStorage.getItem("token");
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  const toggleExpand = (id) => {
    setExpandedBlogs(prev => ({...prev, [id]:!prev[id] }));
  };

  const fetchBlogs = useCallback(async () => {
    setLoading(true);
    try {
      const limit = isAdmin? 20 : 12;
      const res = isAdmin? await getAllBlogsAdmin(1, 20) : await getBlogs(page, limit);

      const blogData = res.blogs || res.data || res;
      const newBlogs = Array.isArray(blogData)? blogData : [];

      if(page === 1 || isAdmin) setBlogs(newBlogs);
      else setBlogs(prev => [...prev,...newBlogs]);

      setHasMore(newBlogs.length === limit);

    } catch (err) {
      console.log("Error:", err);
    } finally {
      setLoading(false);
    }
  }, [isAdmin, page]);

  useEffect(() => {
    fetchBlogs();
  }, [fetchBlogs]);

  const handleCreateBlogClick = () => {
    if (isLoggedIn) navigate("/create-blog");
    else setShowPopup(true);
  };

  const loadMore = () => setPage(prev => prev + 1);

  return (
    <>
      <Navbar />
      <SecondNavbar /> {/* 👈 YE WALI LINE ADD KI HAI */}

      {showPopup && (
        <div style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999}}>
          <div style={{background: '#fff', padding: '30px', borderRadius: '10px', textAlign: 'center'}}>
            <h3>Login Required</h3>
            <button onClick={() => navigate("/login")} className="create-blog-btn">Login</button>
            <button onClick={() => setShowPopup(false)} className="create-blog-btn" style={{background: '#999', marginLeft: '10px'}}>Cancel</button>
          </div>
        </div>
      )}

      <header className="main-hero">
        <h1>{isAdmin? `Admin Dashboard - Total Blogs: ${blogs.length}` : "Voices For The Earth 🌍"}</h1>
        <p>Join our community of eco-warriors and share your story</p>
      </header>

      <div className="blog-grid">
        {loading && page === 1? <p style={{textAlign:'center', padding:'50px'}}>Loading Blogs...</p> :
        blogs.length === 0? <p style={{textAlign:'center'}}>No blogs found</p> :
        blogs.map((blog) => (
          <div key={blog._id} className="premium-card">
            <div className="card-img">
              <img
                // ✅ FIX: /uploads/ add karo warna image nahi aayegi
                src={blog.image? `/uploads/${blog.image}` : healthImg}
                className="blog-image"
                alt={blog.title}
                loading="lazy"
              />
            </div>
            <span className="badge">{blog.category}</span>
            <h2>{blog.title}</h2>

            {openBlogId === blog._id? (
              <>
                <p className="blog-description">{blog.description}</p>
                {blog.author && <p><b>By:</b> {blog.author.name || blog.author}</p>}
                <p><b>Date:</b> {new Date(blog.createdAt).toLocaleDateString()}</p>
                <button onClick={() => setOpenBlogId(null)} className="create-blog-btn" style={{marginTop: '10px', background: '#999'}}>Close</button>
              </>
            ) : (
              <>
                <p className="blog-description">
                  {expandedBlogs[blog._id]? blog.description : blog.description?.length > 200? blog.description.slice(0, 200) + "..." : blog.description}
                </p>
                {blog.description?.length > 200 && (
                  <button onClick={() => toggleExpand(blog._id)} className="show-more-btn" style={{background: "none", border: "none", color: "#2e7d32", cursor: "pointer", fontWeight: 600, marginBottom: "10px"}}>
                    {expandedBlogs[blog._id]? "Show Less" : "Show More"}
                  </button>
                )}
                <button onClick={() => setOpenBlogId(blog._id)} className="create-blog-btn" style={{marginTop: '10px'}}>Read More</button>
              </>
            )}
            {!blog.isApproved && isAdmin && <span style={{color:'orange', fontWeight:'bold', marginLeft:'10px'}}>Pending</span>}
          </div>
        ))}
      </div>

      {!isAdmin && hasMore && (
        <div style={{textAlign:'center', margin:'40px 0'}}>
          <button onClick={loadMore} className="create-blog-btn" disabled={loading}>
            {loading? "Loading..." : "Load More Blogs"}
          </button>
        </div>
      )}

      <div className="create-blog-section">
        <button className="create-blog-btn" onClick={handleCreateBlogClick}>
          {isLoggedIn? "+ Create Blog" : "Login to Create Blog"}
        </button>
      </div>
      <Footer /> 
    </>
  );
};
export default Blog;